import React from 'react';
import { Field } from 'redux-form';
import { toNumberString } from 'app/util/normalizers';
import { isNumber, required, minLength, noopValidate } from 'app/util/validators';
import { renderInputBase } from 'app/components/FormFields/_renderInputBase';
import { mapAutoCompleteName } from 'app/util/autocomplete';

export const ZipCode = (props) => {
  const { name, isOptional } = props;
  const isRequired = isOptional ? noopValidate : required;
  return (
    <Field
      autoComplete = {mapAutoCompleteName(name)}
      component    = {renderInputBase}
      label        = {props.label}
      maxLength    = {5}
      name         = {name}
      normalize    = {toNumberString}
      type         = "tel"
      validate     = {[isRequired, isNumber, minLength(5)]}
    />
  );
};
